import { Box } from "@mui/material";
import "./_style.scss";
import { useContext, useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { GlobalContext } from "../../context/globalContext";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { BusinessContext } from "../../context/businessContext";
import { fakeTableList, schema } from "./parts";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import { httpAPI_CON025, httpAPI_CON020 } from "./api/request";
import TkBackButton from "../../components/molecules/TkBackButton";
import { changeZipcodeFormat } from "../../utils/useTools";
import { Prefectures } from "../../assets/data/Constants";
import _ from "lodash";
import { TkRouteContext } from "../../context/tkRouteContext";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { TkGetCode } from "../../utils/TkGetCode";

/**
 * SCRC040106 契約者・法人担当者情報の確認・変更
 * @return SCRC040106 契約者・法人担当者情報の確認・変更
 */
const SCRC040106 = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const [tableList, setTableList] = useState<any>([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  const [tel, setTel] = useState("");
  const isKiko =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const contractorNo = isKiko
    ? businessState.common?.contractorNo
    : state.authInfo?.contractorNo;
  const [open, setOpen] = useState(false);
  const { state: routerState, setState: setRouterState } =
    useContext(TkRouteContext);
  const wantToSetInRouterList = useRef<any>(
    location.state?.wantToSetInRouterList ?? []
  );

  useEffect(() => {
    if (wantToSetInRouterList.current.length === 0) return;
    if (_.isEqual(wantToSetInRouterList.current, routerState.routerList))
      return;
    setRouterState({
      routerList: wantToSetInRouterList.current as any,
    });
  }, [wantToSetInRouterList, routerState.routerList, setRouterState]);

  const handleInit = async () => {
    let resArr = stateFakeTableList.current;
    let contractorName = resArr.find(
      (item) => item.keyword === "contractorName"
    )!;
    contractorName.showLine = isKiko;
    contractorName.contractorNumber =
      businessState.common?.contractorNo +
      ":" +
      businessState.common?.contractorName;
    let contactTel = resArr.find((item) => item.keyword === "contactTel")!;
    contactTel.onGetInputValue = (value: any) => {
      setTel(value.target.valueForShow);
    };

    try {
      const res = await httpAPI_CON025({
        contractorNo,
      });

      if (res.resultCd === "I0000") {
        resArr.find((item) => item.keyword === "businessOwnerClass")!.text =
          res.businessOwnerClass;
        resArr.find((item) => item.keyword === "corpName")!.text = res.corpName;
        resArr.find((item) => item.keyword === "corpNameKana")!.text =
          res.corpNameKana;
        resArr.find(
          (item) => item.keyword === "directorTitle"
        )!.setDefaultValue = res.directorTitle;
        resArr.find(
          (item) => item.keyword === "directorName"
        )!.setDefaultValue = res.directorName;
        resArr.find((item) => item.keyword === "zipcode")!.text =
          changeZipcodeFormat(res.zipcode);
        resArr.find((item) => item.keyword === "address")!.valueObject = {
          prefectures: TkGetCode(Prefectures, res.prefectureCd),
          city: res.addressCity!,
          address: res.addressOthers!,
        };
        resArr.find((item) => item.keyword === "corpNumber")!.text =
          res.corpNumber;
        resArr.find((item) => item.keyword === "tel")!.text = res.tel;
        resArr.find((item) => item.keyword === "fax")!.text = res.fax;
        resArr.find((item) => item.keyword === "deptName")!.setDefaultValue =
          res.deptName;
        resArr.find((item) => item.keyword === "position")!.setDefaultValue =
          res.position;
        resArr.find((item) => item.keyword === "name")!.setDefaultValue =
          res.name;
        contactTel.setDefaultValue = res.contactTel;
        resArr.find(
          (item) => item.keyword === "contactEmail"
        )!.setDefaultValue = res.contactEmail;

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }

    setTableList([...resArr]);
  };

  // 初期表示
  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (data: any) => {
    try {
      const res = await httpAPI_CON020({
        contractorNo,
        directorTitle: data.directorTitle,
        directorName: data.directorName,
        deptName: data.deptName,
        position: data.position,
        name: data.name,
        tel,
        contactEmail: data.contactEmail,
      });

      if (res.resultCd === "I0000") {
        setBusinessState({
          ...businessState,
          job_114: {
            ...businessState.job_114,
            contractorNo,
          },
        });
        setState({
          ...state,
          errorMsgId: "",
        });

        setOpen(true);
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box data-testid="SCRC040106PageForTest" className="tkSCRC040106">
      <TkFakeTable
        list={tableList}
        ruleSchema={schema}
        buttonGroup={<TkBackButton />}
        submitButtonText="更新"
        onCheckAndSubmit={handleSubmit}
      />

      <TkMessageDialog
        open={open}
        onOky={() => setOpen(false)}
        title="更新完了"
        contextText="　契約者・担当者情報の更新が完了しました"
        okText="はい"
        cancelText=""
      />
    </Box>
  );
};

export default SCRC040106;
